<template>
  <div style="height: 100vh;">
    <div class="loader-screen" id="splashscreen">
      <div class="main-screen">
      </div>
    </div>
    <!-- splash-->

    <div class="">
      <!-- Page Content -->
      <div class="page-content page page-onboading">
        <!-- Onboading Start -->
        <div class="started-swiper-box">
          <div class="swiper-container get-started">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="slide-info">
                  <div class="dz-media">
                    <img src="../../assets/Concert_Gospel.png" alt="image"/>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="slide-info">
                  <div class="dz-media">
                    <img src="../../assets/Manger.png" alt="image"/>
                  </div>
                </div>
              </div>
              <!-- <div class="swiper-slide">
                  <div class="slide-info">
                      <div class="dz-media">
                          <img src="assets/images/stock.svg" alt="image"/>
                      </div>
                  </div>
              </div> -->
              <div class="swiper-slide">
                <div class="slide-info">
                  <div class="dz-media">
                    <img src="../../assets/BOIRE.png" alt="image"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-btn">
            <div class="swiper-pagination style-1 flex-1"></div>
          </div>
          <div class="slide-content">
            <h5 class="">{{ "CONCERT LIVE" }}</h5>
            <p class="">{{ "Moment convivial de musique et de partage" }}</p>
<!--            <p>{{$t('boading_text')}}</p>-->
          </div>
        </div>
        <!-- Onboading End-->
      </div>
      <!-- Page Content End-->
      <!-- Footer -->
      <footer class="footer border-0">
        <div class="container">
          <router-link :to="{name: 'pseudo-page'}" class="btn btn-primary btn-rounded d-block">{{ $t('start') }}</router-link>
        </div>
      </footer>
      <!-- Footer End-->
    </div>
  </div>
</template>

<script setup>

import {useScript} from "@/composables/useScript";
import {onMounted} from "vue";

const {
  $headerLink,
} = useScript()

onMounted(()=>{
  $headerLink('assets/libs/wow/css/libs/animate.css')
})
</script>

<style scoped>
.main-screen{
  background-image: url('../../assets/splash.png');
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>